/* Reviewed ingredient ideas only. No commerce, network or analytics calls. */
(function (root) {
  'use strict';
  function safeRecipeURL(value) {
    return typeof value === 'string' && !/[\\\u0000-\u0020\u007f]/.test(value) &&
      (/^https:\/\/slibuddies\.net\//.test(value) || /^\/(?!\/)/.test(value));
  }
  function classify(card, mapping) {
    var entry = mapping[card.id];
    var result = {id:card.id, group:card.group, nutrients:[], skills:{}, reviewed:false};
    if (!entry || entry.handle !== card.handle) return result;
    result.reviewed = true;
    result.nutrients = (entry.nutrients || []).filter(function (token) {
      return ['iron','zinc','dha','protein'].indexOf(token) !== -1;
    });
    ['grasp','pincer'].forEach(function (skill) {
      var value = (entry.skills || {})[skill];
      if (!value || !value.prep || typeof value.prep.en !== 'string' || !value.prep.en.trim() ||
          typeof value.prep.zh !== 'string' || !value.prep.zh.trim() || !Array.isArray(value.sources) ||
          !value.sources.some(function (source) { return typeof source === 'string' && source.trim(); })) return;
      var reviewed = {prep:value.prep, sources:value.sources, adaptation:value.adaptation === true, linkType:'none'};
      if ((value.linkType === 'recipe' || (!value.linkType && value.recipeId)) && value.recipeId &&
          value.url && safeRecipeURL(value.url.en) && safeRecipeURL(value.url.zh)) {
        reviewed.linkType = 'recipe'; reviewed.recipeId = value.recipeId; reviewed.url = value.url;
      }
      result.skills[skill] = reviewed;
    });
    return result;
  }
  function select(cards, choices) {
    choices = choices || {};
    return cards.filter(function (card) {
      return (!choices.ingredient || choices.ingredient === 'all' || card.group === choices.ingredient) &&
        (!choices.nutrition || choices.nutrition === 'all' || card.nutrients.indexOf(choices.nutrition) !== -1) &&
        (!choices.skill || choices.skill === 'all' || Object.prototype.hasOwnProperty.call(card.skills, choices.skill));
    });
  }
  var api = {classify:classify, select:select};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.IbBabyFilters = api;
  if (typeof document === 'undefined') return;
  function start() {
    var collection = document.querySelector('.ib-baby-collection');
    var panel = document.querySelector('[data-ib-baby-filters]');
    var data = document.querySelector('[data-ib-baby-support-data]');
    if (!collection || !panel || !data) return;
    var mapping;
    try { mapping = JSON.parse(data.textContent); } catch (error) { return; }
    var nodes = Array.from(collection.querySelectorAll('.product-grid .product-block[data-ib-product-id]'));
    if (!nodes.length) return;
    var records = nodes.map(function (node) {
      return classify({id:node.getAttribute('data-ib-product-id'),handle:node.getAttribute('data-ib-handle'),group:node.getAttribute('data-ib-group')}, mapping);
    });
    var choices = {ingredient:'all',nutrition:'all',skill:'all'};
    var status = collection.querySelector('.ib-filter-status');
    var empty = collection.querySelector('[data-ib-filter-empty]');
    var safety = collection.querySelector('[data-ib-skill-safety]');
    var locale = panel.getAttribute('data-ib-language') === 'zh' ? 'zh' : 'en';
    function render() {
      var selected = select(records, choices);
      collection.classList.toggle('ib-single-result', selected.length === 1);
      var ids = selected.map(function (record) { return record.id; });
      nodes.forEach(function (node, index) {
        node.hidden = ids.indexOf(records[index].id) === -1;
        var existing = node.querySelector('.ib-skill-preparation');
        if (existing) existing.remove();
        var guidance = records[index].skills[choices.skill];
        if (node.hidden || !guidance) return;
        var note = document.createElement('div');
        note.className = 'ib-skill-preparation';
        var text = document.createElement('p');
        text.textContent = guidance.prep[locale];
        note.appendChild(text);
        if (guidance.linkType === 'recipe' && guidance.url) {
          var link = document.createElement('a');
          link.href = guidance.url[locale];
          link.textContent = panel.getAttribute('data-ib-recipe-label');
          note.appendChild(link);
        }
        node.querySelector('.product-block__inner').appendChild(note);
      });
      panel.querySelectorAll('[data-ib-dimension]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(choices[button.getAttribute('data-ib-dimension')] === button.getAttribute('data-ib-choice')));
      });
      status.textContent = (locale === 'zh' ? '顯示 ' : 'Showing ') + selected.length + ' / ' + records.length +
        (locale === 'zh' ? ' 款食材' : ' products');
      empty.hidden = selected.length !== 0;
      if (safety) {
        safety.hidden = choices.skill === 'all';
        safety.textContent = safety.hidden ? '' : safety.getAttribute('data-ib-' + choices.skill + '-note');
      }
    }
    panel.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ib-dimension]');
      if (button) { choices[button.getAttribute('data-ib-dimension')] = button.getAttribute('data-ib-choice'); render(); }
    });
    collection.querySelectorAll('[data-ib-filter-reset]').forEach(function (button) {
      button.addEventListener('click', function () {
        choices = {ingredient:'all',nutrition:'all',skill:'all'};
        render();
        panel.querySelector('[data-ib-filter-reset]').focus();
      });
    });
    render();
    collection.querySelectorAll('.results-count').forEach(function (count) { count.hidden = true; });
    panel.hidden = false; status.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
}(typeof window === 'undefined' ? {} : window));
